import { SelectProps } from '@chakra-ui/react';
import { FC } from 'react';
import AppFormControl from './AppFormControl';

import SelectInput from 'presentation/components/shared/fields/SelectInput';

interface Props extends Omit<SelectProps, 'name'>, FormFieldProps {}

const FormSelectInput: FC<Props> = ({ label, helperText, ...props }) => {
  return (
    <AppFormControl name={props.name} label={label} helperText={helperText}>
      <SelectInput {...props} />
    </AppFormControl>
  );
};

export default FormSelectInput;
